export default {
  name: 'OurStory',
  data() {
    return {
    };
  },
};
